<div class="time-header-container">
  <div class="row between-xs middle-xs parada-header">
    <div class="col-xs">
      <span class="parada-label"> PARADA </span>
    </div>

    <div class="col">
      <ty-save-favorites
        [stop]="stop"
        [busId]="busId"
        [busname]="busname"
        [busCode]="busCode"
        [stopName]="stopName"
        [direction]="direction"
        [routes]="listOfRoutes.subtasks"
        [disabled]="loadingSpinner || loadingSiriSpinner"
      >
      </ty-save-favorites>
    </div>
  </div>
  <div class="row row-header">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <mat-icon class="bus-icon" (click)="backClicked()">keyboard_arrow_left</mat-icon>
      <h1 class="times-title">{{ stopName }} ({{ stopCode }})</h1>
      <ul class="bus-selector">
        <li *ngFor="let subtask of listOfRoutes.subtasks">
          <mat-checkbox
            class="time-calculator-check"
            [style]="'background-color: #' + subtask.route_color + ';'"
            [(ngModel)]="subtask.selected"
            [color]="subtask.color"
            (ngModelChange)="changeStopTimes()"
          >
            {{ subtask.busName }}
          </mat-checkbox>
        </li>
      </ul>
    </div>
  </div>
</div>

<section class="example-section">
  <mat-tab-group
    mat-align-tabs="center"
    [selectedIndex]="activeTab"
    [color]="'primary'"
    [backgroundColor]="'primary'"
  >
    <!-- TODAY TAB -->
    <mat-tab label="Hoy">
      <div *ngIf="loadingSpinner">
        <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="dataSource.length === 0 && !loadingSpinner" class="no-results">
        <h3>No se encuentran resultados para Hoy.</h3>
      </div>

      <section class="estimated-time-container">
        <h3>Tiempo Estimado de Llegada</h3>
        <!-- Botón para refrescar las estimaciones -->
        <button class="refresh-button" (click)="refreshEstimations()">
          Actualizar Estimaciones
        </button>
        <div *ngFor="let line of estimatedTimes">
          <div class="line-header">
            <h4>{{ line.line }} - {{ line.route }}</h4>
          </div>
          <div class="estimated-times">
            <p *ngFor="let estimation of line.estimations">{{ estimation.minutesToArrival }} min</p>
          </div>
        </div>
      </section>

      <section class="estimated-time-container">
        <h3>Horarios para las lineas seleccionadas</h3>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="minutes-column"
              [class.last-stop]="element.isLastStop"
            >
              <p class="minutes" *ngFor="let hour of element.name">
                {{ element.position }}:{{ hour.minute }}
                <span
                  class="time-calculator"
                  [style]="'background-color: #' + hour.route_color + ';'"
                  >{{ hour.stop }}</span
                >
              </p>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </section>
    </mat-tab>

    <mat-tab label="Por fecha" class="date-tab">
      <mat-form-field appearance="fill" class="date-formfield">
        <mat-label>Seleccione una fecha</mat-label>
        <input matInput [matDatepicker]="picker" disabled (dateChange)="dateSelectEvent($event)" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker disabled="false" #picker></mat-datepicker>
      </mat-form-field>

      <div *ngIf="loadingSpinner">
        <mat-spinner></mat-spinner>
      </div>
      <section class="estimated-time-container">
        <h3>Horarios para las lineas seleccionadas</h3>
        <div *ngIf="dateDataSource.data.length === 0 && !loadingSpinner" class="no-results">
          <h3 *ngIf="dateSelectedString">
            No se encuentran resultados para la fecha seleccionada.
          </h3>
          <h3 *ngIf="!dateSelectedString">No se ha seleccionado ninguna fecha.</h3>
        </div>

        <table
          *ngIf="dateDataSource.data.length !== 0 && !loadingSpinner"
          mat-table
          [dataSource]="dateDataSource"
          class="mat-elevation-z8"
        >
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Minutos</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="minutes-column"
              [class.last-stop]="element.isLastStop"
            >
              <p class="minutes" *ngFor="let hour of element.name">
                {{ element.position }}:{{ hour.minute }}
                <span
                  class="time-calculator"
                  [style]="'background-color: #' + hour.route_color + ';'"
                  >{{ hour.stop }}</span
                >
              </p>
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsDate"></tr>
        </table>
      </section>
    </mat-tab>
  </mat-tab-group>
</section>
